module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [(_vm.user) ? _c('div', [_c('h3', [_vm._v("Utilisateurs > " + _vm._s(_vm.user.username))]), _c('div', {
    staticClass: "panel panel-default"
  }, [_c('dl', [_c('dt', [_vm._v("email")]), _c('dd', [_vm._v(_vm._s(_vm.user.email))])])]), _c('button', {
    staticClass: "btn btn-default",
    attrs: {
      "type": "button"
    },
    on: {
      "click": _vm.editUser
    }
  }, [_vm._v("modifier les informations")])]) : _vm._e()])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler.js?id=data-v-e0ef6730!./~/vue-loader/lib/template-loader.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/user/UserProfile.vue
// module id = 605
// module chunks = 2